export default __webpack_public_path__ + "static/media/japanese-market.8659dbd7.jpg";